/**
 * voteRule接口
 */
import axios from '../utils/https' // 导入http中创建的axios实例

const voteRule = {
  getRootRules () {
    return axios.get('/api/voteRule/GetRootRules')
  },
  getScreenRules (params) {
    return axios.get('/api/voteRule/GetScreenRules', { params })
  },
  getScreenRule (params) {
    return axios.get('/api/voteRule/GetScreenRule', { params })
  },
  editScreenRule (params) {
    return axios.post('/api/voteRule/EditScreenRule', params)
  },
  getRules (params) {
    return axios.get('/api/voteRule/GetRules', { params })
  },
  getRulesByCompanyId (params) {
    return axios.get('/api/voteRule/GetRulesByCompanyId', { params })
  },
  copyRule (params) {
    return axios.post('/api/voteRule/CopyRule', params)
  },
  getRule (params) {
    return axios.get('/api/voteRule/GetRule', { params })
  },
  getRuleDetails (params) {
    return axios.get('/api/voteRule/GetRuleDetails', { params })
  },
  editRule (params) {
    return axios.post('/api/voteRule/EditRule', params)
  },
  editRuleDetails (params) {
    return axios.post('/api/voteRule/EditRuleDetails', params)
  },
  deleteRule (params) {
    return axios.delete('/api/voteRule/DeleteRule', { params })
  },
  getRuleItmes (params) {
    return axios.get('/api/voteRule/GetRuleItmes', { params })
  },
  getRuleItem (params) {
    return axios.get('/api/voteRule/GetRuleItem', { params })
  },
  editRuleItem (params) {
    return axios.post('/api/voteRule/EditRuleItem', params)
  },
  deleteRuleItem (params) {
    return axios.delete('/api/voteRule/DeleteRuleItem', { params })
  }
}

export default voteRule
